import { t } from '../../app/i18n';

export default {
  //CONFIRM_EMAIL: 'CONFIRM_EMAIL',
  ENTER_SMS_CODE_CONTRACT: 'ENTER_SMS_CODE_CONTRACT',
  // FILL_CONTRACT_NUMBER: 'FILL_CONTRACT_NUMBER', // docastne odstranene zadavanie cislo ramcovej zmluvy
  SIGN_CONTRACT: 'SIGN_CONTRACT',
  SIGN_INSURANCE_CONTRACT: 'SIGN_INSURANCE_CONTRACT',
  UPLOAD_DOCUMENTS: 'UPLOAD_DOCUMENTS',
  WAIT_FOR_DOCUMENT_CONFIRMATION: 'WAIT_FOR_DOCUMENT_CONFIRMATION',
  GENERAL_CONTRACT_SIGN: 'GENERAL_CONTRACT_SIGN',
  UPLOAD_BANK_ACCOUNT_STATEMENTS: 'UPLOAD_BANK_ACCOUNT_STATEMENTS',
  PRESCORING_FAILED: 'PRESCORING_FAILED',
  SIGN_ALL_CONTRACTS: 'SIGN_ALL_CONTRACTS',
  DOCUMENTS_REJECTED: 'DOCUMENTS_REJECTED',
};

export const translation = {
  // CONFIRM_EMAIL: t(
  //   'Na Vašu e-mailovú adresu, ktorú ste zadali pri registrácii, sme odoslali aktivačný e-mail. Prosím, skontrolujte svoju schránku a postupujte podľa pokynov v e-maili.'
  // ),
  ENTER_SMS_CODE_CONTRACT: t(
    'Opätovne potvrďte Žiadosť o pôžičku prostredníctvom sms kódu, ktorý v krátkej chvíli obdržíte na telefónnom čísle. Pre vloženie sms kódu kliknite sem.'
  ),
  ENTER_SMS_CODE_CONTRACT_WITH_INSURANCE: t('Opätovne potvrďte Žiadosť o pôžičku a Žiadosť o zabezpečenie poistenia prostredníctvom sms kódu, ktorý v krátkej chvíli obdržíte na telefónnom čísle. Pre vloženie sms kódu kliknite sem.'),
  // FILL_CONTRACT_NUMBER: t('Vložte číslo rámcovej zmluvy'), // docastne odstranene zadavanie cislo ramcovej zmluvy
  SIGN_CONTRACT: t(
    'Vaša identita bola úspešne overená. Pre využívanie našich služieb prosím kliknite na tento odkaz a potvrďte rámcovú zmluvu.'
  ),
  SIGN_INSURANCE_CONTRACT: t(
    'Pre začatie čerpania pôžičky prosím podpíšte zmluvu o poistení.'
  ),
  UPLOAD_DOCUMENTS: t(
    'Pre overenie Vašej identity je potrebné nahrať sken prednej, aj zadnej strany občianskeho preukazu. Po nahratí odošlite na schválenie.'
  ),
  WAIT_FOR_DOCUMENT_CONFIRMATION: t(
    'Vaša totožnosť bude overená administrátorom. Následne Vám zašleme emailom informáciu ohľadom dokončenia Vašej žiadosti.'
  ),
  GENERAL_CONTRACT_SIGN: t(
    'Vážený klient, pripravili sme pre Vás novú verziu Dlžníckej rámcovej zmluvy. Ak chcete požiadať o ďalšiu pôžičku kliknutím na tento odkaz prečítajte a schváľte prosím novú verziu dokumentu.'
  ),
  UPLOAD_BANK_ACCOUNT_STATEMENTS: t(
    'Pre získanie pôžičky je potrebné nahrať dva výpisy z bankového účtu, na ktorý Vám chodí výplata a je registrovaný na Vaše meno, prípadne máte k nemu dispozičné právo. Ďalej nahrajte aj dve výplatné pásky za posledné 2 mesiace. Po nahratí odošlite na schválenie.'
  ),
  UPLOAD_PSD2_BANK_ACCOUNT_STATEMENTS : t(
    'Pre získanie pôžičky je potrebné žiadosť overiť na základe výpisu z Vášho bankového účtu, na ktorý Vám chodí výplata a je registrovaný na Vaše meno, prípadne k nemu máte dispozičné právo. Overenie prebieha online autorizáciou alebo manuálnym nahratím výpisu do systému.'
  ),
  PRESCORING_FAILED: t(
    'Je nám ľúto, ale Vaša žiadosť bola zamietnutá, keďže nespĺňa potrebné požiadavky na získanie pôžičky.'
  ),
  SIGN_ALL_CONTRACTS: t(
    'Pre využívanie našich služieb záväzne potvrďte nižšie uvedené zmluvy, tým že označíte checkboxy s ich súhlasom a stlačíte tlačidlo Potvrdiť všetky zmluvy.'
  ),
  DOCUMENTS_REJECTED: t(
    'Je nám ľúto, ale Vaša žiadosť bola zamietnutá, keďže nespĺňa potrebné požiadavky na získanie pôžičky.'
  ),
};



// WEBPACK FOOTER //
// ./src/common/enums/debtorRegistrationActions.js